var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAscendingHovered(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "type=ascending, states=hovered"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5.31854 12.1996L9.32543 7.46518C9.54688 7.20352 9.65761 7.07269 9.80206 7.02875C9.92807 6.99042 10.0719 6.99042 10.1979 7.02875C10.3424 7.07269 10.4531 7.20352 10.6746 7.46518L14.6815 12.1996C14.9037 12.4622 15.0148 12.5935 14.9984 12.7013C14.9841 12.7953 14.9121 12.8807 14.8004 12.9363C14.6723 13 14.4505 13 14.0069 13H5.99311C5.54953 13 5.32774 13 5.19964 12.9363C5.0879 12.8807 5.01592 12.7953 5.00159 12.7013C4.98517 12.5935 5.09629 12.4622 5.31854 12.1996Z",
    stroke: "#218BFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscendingHovered);
export default __webpack_public_path__ + "static/media/ascending-hovered.150a44b27dab15ed28e5f99ced0c9efe.svg";
export { ForwardRef as ReactComponent };